import enNotifications from '../translations/en/notifications.json';
import deNotifications from '../translations/de/notifications.json';
import frNotifications from '../translations/fr/notifications.json';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '../translations/en/common.json';
import deCommon from '../translations/de/common.json';
import frCommon from '../translations/fr/common.json';
import enAccount from '../translations/en/account.json';
import deAccount from '../translations/de/account.json';
import frAccount from '../translations/fr/account.json';
import enInvoice from '../translations/en/invoice.json';
import deInvoice from '../translations/de/invoice.json';
import frInvoice from '../translations/fr/invoice.json';
import enCountry from '../translations/en/country.json';
import deCountry from '../translations/de/country.json';
import frCountry from '../translations/fr/country.json';
import { LanguageCodes } from '../config/enums/Language';
import { getLanguageFromLocalStorage } from '../translations/langUtils';

i18next.use(initReactI18next).init({
   initImmediate: false,
   fallbackLng: LanguageCodes.DEFAULT,
   lng: getLanguageFromLocalStorage(),
   interpolation: {
      escapeValue: false,
   },
   supportedLngs: [LanguageCodes.ENGLISH, LanguageCodes.DEUTSCH, LanguageCodes.FRENCH],
   resources: {
      en: {
         notifications: enNotifications,
         common: enCommon,
         account: enAccount,
         invoice: enInvoice,
         country: deCountry,
      },
      de: {
         notifications: deNotifications,
         common: deCommon,
         account: deAccount,
         invoice: deInvoice,
         country: enCountry,
      },
      fr: {
         notifications: frNotifications,
         common: frCommon,
         account: frAccount,
         invoice: frInvoice,
         country: frCountry,
      },
   },
});

export default i18next;
